import React from 'react';

interface TrackTypeSelectorProps {
  selectedTrackType: 'drag' | 'drift';
  setSelectedTrackType: (type: 'drag' | 'drift') => void;
  resetTimeSelections: () => void;
}

const TrackTypeSelector: React.FC<TrackTypeSelectorProps> = ({ 
  selectedTrackType, 
  setSelectedTrackType,
  resetTimeSelections
}) => {
  const handleTrackTypeChange = (type: 'drag' | 'drift') => {
    setSelectedTrackType(type);
    resetTimeSelections();
  };

  return (
    <div className="flex justify-center gap-4 mb-12">
      <button
        onClick={() => handleTrackTypeChange('drag')}
        className={`px-6 py-3 rounded-lg text-lg font-semibold transition-colors ${
          selectedTrackType === 'drag'
            ? 'bg-primary-600 text-white'
            : 'bg-zinc-800 text-gray-300 hover:bg-zinc-700'
        }`}
      >
        Drag Strip
      </button>
      <button
        onClick={() => handleTrackTypeChange('drift')}
        className={`px-6 py-3 rounded-lg text-lg font-semibold transition-colors ${
          selectedTrackType === 'drift'
            ? 'bg-primary-600 text-white'
            : 'bg-zinc-800 text-gray-300 hover:bg-zinc-700'
        }`}
      >
        Drift Track
      </button>
    </div>
  );
};

export default TrackTypeSelector;